import { MassUnit } from "../../../../../types/process/process.types";
import {
  InternalTransportRecord,
  TransportType
} from "../../../../../types/prodcut-data-review/product-data.types";
import { InternalTransportFormValues } from "../types/internalTransportTable.types";

export const toFormValues = (r: InternalTransportRecord): InternalTransportFormValues => ({
  id: r.id,
  name: r.name,
  averageDistance: r.averageDistance === "" ? "" : String(r.averageDistance),
  transportType: r.transportType ?? "",
  weight: r.weight === "" ? "" : String(r.weight),
  weightUnit: r.weightUnit
});

export const fromFormValues = (data: InternalTransportFormValues): Partial<InternalTransportRecord> => ({
  name: data.name,
  averageDistance: data.averageDistance === "" ? "" : Number(data.averageDistance),
  transportType: data.transportType as TransportType | "",
  weight: data.weight === "" ? "" : Number(data.weight),
  weightUnit: data.weightUnit as MassUnit
});
